"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWeeklyScheduleForm = void 0;
const core_1 = require("@veeam/core");
require("../types");
require("../models");
const useWeeklyScheduleForm = (model) => {
    return core_1.useForm(model);
};
exports.useWeeklyScheduleForm = useWeeklyScheduleForm;
//# sourceMappingURL=useWeeklyScheduleForm.js.map